import { Component, ElementRef, HostListener, OnInit, inject } from '@angular/core';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { AuthQuery, RailMyBoxRoles } from '@railmybox/auth';
import { SupportMenuItem, supportMenuItems } from './support-items';

@Component({
  selector: 'rmb-support-nav',
  templateUrl: './support-nav.component.html',
  styleUrls: ['./support-nav.component.scss'],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: [{ scope: 'support', alias: 'support' }],
    },
  ],
  standalone: false,
})
export class SupportNavComponent implements OnInit {
  private elementRef = inject(ElementRef);
  private authQuery = inject(AuthQuery);

  readonly TRANSLOCO_PREFIX = 'support.navigation';
  isExpanded: boolean;
  items: SupportMenuItem[] = [];

  toggleSidebar() {
    this.isExpanded = !this.isExpanded;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isExpanded = false;
    }
  }

  ngOnInit() {
    const userRoles = this.authQuery.getUserRoles();
    const isAdmin = userRoles.includes(RailMyBoxRoles.ADMIN);

    this.items = supportMenuItems.map((item) => this.applyAccessState(item, userRoles, isAdmin));
  }

  private applyAccessState(item: SupportMenuItem, userRoles: string[], isAdmin: boolean): SupportMenuItem {
    const hasAccess = isAdmin || !item.roles || item.roles.some((role) => userRoles.includes(role));
    const subItems = item.items?.map((sub) => this.applyAccessState(sub, userRoles, isAdmin));

    return { ...item, restricted: !hasAccess, items: subItems };
  }
}
